import { Component } from '@angular/core'

@Component({
  selector: 'app-mygalleries',
  templateUrl: './mygalleries.component.html',
  styleUrl: './mygalleries.component.scss'
})
export class MygalleriesComponent {
    query: string = '';
}
